import React from "react";
import { Flex, Text } from "@chakra-ui/react";

import { SalePriceProps } from "../../interface/interface";

const SalePrice: React.FC<SalePriceProps> = ({ actualPrice, price }) => (
  <Flex flexDirection="column" gap="2px">
    <Text>AED {actualPrice} </Text>
    <Text color="gray.600" textDecoration="line-through">
      AED {price}
    </Text>
  </Flex>
);

export { SalePrice };
